import {ComponentProps} from 'react'
import {withClassNames} from 'quickstart/theme'
import S from './styles.module.css'

export const OuterContainer = withClassNames(S.outer)('div')

export const InnerContainer = withClassNames(S.inner)('div')

export const Container = (props: ComponentProps<typeof InnerContainer>) => (
  <OuterContainer>
    <InnerContainer {...props} />
  </OuterContainer>
)
